module.exports = __webpack_public_path__ + "img/socio3.93284d3c.png";